import { render } from "./AltaCanalForm.vue?vue&type=template&id=57613c2c&scoped=true"
import script from "./AltaCanalForm.vue?vue&type=script&lang=js"
export * from "./AltaCanalForm.vue?vue&type=script&lang=js"

import "./AltaCanalForm.vue?vue&type=style&index=0&id=57613c2c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57613c2c"]])

export default __exports__